import type { SyntheticEvent } from 'react'

import { getImageSrcKey } from '@/lib/Images/imageSrcKeys.ts'

export const DEFAULT_IMAGE_SRC = '/images/default.webp'
export const DEFAULT_IMAGE_64_SRC = '/images/default-64.webp'
export const DEFAULT_FAVICON_SRC = '/default.ico'

export function applyImageFallback(
    event: SyntheticEvent<HTMLImageElement, Event>,
    fallbackSrc = DEFAULT_IMAGE_SRC,
) {
    const image = event.currentTarget

    if (
        getImageSrcKey(image.currentSrc || image.src) ===
        getImageSrcKey(fallbackSrc)
    ) {
        image.removeAttribute('src')
        return
    }

    image.src = fallbackSrc
}
